/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOOffBoardingWorkflow from "./DTOOffBoardingWorkflow";
import OffBoardingWorkflowPresenter from "./OffBoardingWorkflowPresenter";
import { useTranslation } from "react-i18next";

function OffBoardingWorkflowController() {
  const [offboardingData, setOffboardingData] = useState({});
  const { t } = useTranslation();

  function getData(data: any) {
    setOffboardingData(data);
  }

  return (
    <>
      <DTOOffBoardingWorkflow setOffboardingData={getData} />
      <OffBoardingWorkflowPresenter
        offboardingData={offboardingData}
        trans={t}
      />
    </>
  );
}

export default OffBoardingWorkflowController;
